import { useParams } from 'react-router';
import { Redirect } from '../Redirect/Redirect';
import styles from "./index.module.css";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input, message } from "antd";
import { Button, Header, Loader } from '../../../components';
import StarRatingUI from './StarRating';
import classNames from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getRideInfo, riderFeedback } from '../../../store/rides';
import { getLoading } from '../../../store/selectors/common';
import { useSelector } from 'react-redux';
import { DateHelper } from '../../../utils';

// export const Survey = () => {
//   const { rideId } = useParams();

//   useEffect(() => {
//     if (rideId) window.location = `https://h0n8tjjl.paperform.co?ride_id=${rideId}`;
//     return;
//   }, [rideId]);
//   return <Redirect />;
// };

// Commenting out custom rider feedback
export const Survey = () => {
  const dispatch = useDispatch();

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const loading = useSelector((state) => getLoading(state));
  const { rideId } = useParams();
  const [rideInfo, setRideInfo] = useState(null);

  useEffect(() => {
    if (rideId) {
      dispatch(getRideInfo(rideId))
        .then((res) => {
           if (res?.data) {
            setRideInfo(res?.data);
          }
        })
        .catch((err) => console.error("Error fetching ride info:", err));
    }
  }, [dispatch, rideId]);

  const handleCancelRide = useCallback((values) => dispatch(
    (riderFeedback({
      payload: {
        rideId,
        rating: values?.rating,
        questionner: {
          onTime: values?.onTime,
          safe: values?.safe,
          comfortable: values?.comfortable,
          discomfortReason: values?.discomfortReason || null,
        },
        additionalComments: values?.comments,
      }
    }))
  ).then((response) => {
    setSubmitted(true);
  }).catch((error) => {
    console.error('Error submitting feedback:', error.response?.data);
    setError(error?.response?.data?.message || 'Failed to submit feedback. Please try again.');
    // message.error(error?.response?.data?.message || 'Failed to submit feedback. Please try again.');
  }), [dispatch, rideId]);

  const FeedbackSchema = Yup.object().shape({
    rating: Yup.number()
      .min(1, "Please select at least 1 star")
      .required("Required"),
    onTime: Yup.string().required("Required"),
    safe: Yup.string().required("Required"),
    comfortable: Yup.string().required("Required"),
    comments: Yup.string(),
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Header role={'RIDER'}></Header>
      <div>
        <Formik
          initialValues={{
            rating: 0,
            onTime: "",
            safe: "",
            comfortable: "",
            discomfortReason: "",
            comments: "",
          }}
          validationSchema={FeedbackSchema}
          onSubmit={(values, { resetForm }) => {
            handleCancelRide(values)
            resetForm();
          }}
        >
          {({ values, setFieldValue, errors, touched, isSubmitting }) => (
            <>
              {submitted && (
                <div className={styles.formContainer}>
                  <h2 className="text-xl font-semibold mb-2">✅ Thank you!</h2>
                  <p>Your feedback has been submitted successfully.</p>
                </div>
              )}

              {/* {error?.length > 0 && (
                <div className={styles.formContainer}>
                  <h2 className="text-xl font-semibold mb-2 text-red-600">❌ Error</h2>
                  <p>{error}</p>
                </div>
              )} */}

              {!submitted && (
                <Form className={classNames({ [styles.formContainer]: true, [styles.box]: true })} >
                  <h1>Rider Feedback</h1>
                  <p >Thank you for riding with MedHaul! Let us know about your most recent ride. We're looking forward to hearing from you.</p>

                  {rideInfo && (
                    <div className={styles.rideDetailsBox}>
                      <h3>Ride Details: </h3> &nbsp;
                      <span>
                        {DateHelper.renderDateTimeWithTZ({
                          dateTime: rideInfo?.pickUpDate,
                          timeZone: rideInfo?.timezone,
                        })}
                      </span>
                    </div>
                  )}
                  <div className={styles.rowStyle}>
                    <label className="block mb-2 font-medium">
                      1. How satisfied were you with your recent ride?
                      {errors.rating && touched.rating && (
                        <span className={styles.required}>*</span>
                      )}<br />
                      <span className={styles.fs10}>1 Star=not satisfied; 5 Stars=very satisfied</span>
                    </label>
                    <StarRatingUI
                      value={values.rating}
                      onChange={(val) => setFieldValue("rating", val)}
                    />
                  </div>

                  {
                    [
                      { name: "onTime", label: "2. Was the driver on time?" },
                      { name: "safe", label: "3. Did you feel safe during the ride?" },
                      {
                        name: "comfortable",
                        label: "4. Would you be comfortable riding with this driver again?",
                      },
                    ].map((q) => (
                      <div key={q.name} className={styles.rowStyle}>
                        <label className="block mb-2 font-medium">
                          {q.label}
                          {errors[q.name] && touched[q.name] && (
                            <span className={styles.required}>*</span>
                          )}
                        </label>
                        <div className={styles.buttonRow}>
                          <Button
                            type="button"
                            myClassName={`${styles.answerBtn} ${values[q.name] === "Yes" ?
                              styles.activeBtn : styles.inactiveBtn}`}
                            onClick={() => setFieldValue(q.name, "Yes")}
                          >
                            Yes
                          </Button>
                          <Button
                            type="button"
                            myClassName={`${styles.answerBtn} ${values[q.name] === "No" ?
                              styles.activeBtn : styles.inactiveBtn}`}
                            onClick={() => setFieldValue(q.name, "No")}
                          >
                            No
                          </Button>
                        </div>

                      </div>
                    ))
                  }
                  {values.comfortable === "No" && (
                    <div className={styles.rowStyle}>
                      <label className="block mb-2 ml-2 font-medium">
                        a. If no, why not? <span className={styles.required}>*</span>
                      </label>
                      <Field
                        as={Input.TextArea}
                        name="discomfortReason"
                        rows={2}
                        placeholder="Write your reason here..."
                      />
                    </div>
                  )}

                  <div className={styles.rowStyle}>
                    <label className="block mb-2 font-medium">
                      5. What could we do better next time?
                    </label>
                    <Field
                      as={Input.TextArea}
                      name="comments"
                      rows={4}
                      placeholder="Write your feedback here..."
                    />
                  </div>

                  <Button type="submit" disabled={isSubmitting} className="w-full">
                    {isSubmitting ? <Loader /> : "Submit Feedback"}
                  </Button>

                </Form>
              )}
            </>
          )}
        </Formik>

      </div>
      <Loader loading={loading} />
    </div>
  );

  {/* <Redirect /> */ }
};
